import { useSelector } from 'react-redux';
import { getSelectedCategory } from '../ducks';

export const useGetSelectedCategory = () => ({
  selectedCategory: useSelector(getSelectedCategory),
});
